import { NavMode } from "../../../../api/robocore/dex_interfaces";
import { loadTextureFromBuffer } from "../../../../api/threed";
import { RobotSlamMap } from "../../../../models/Deployment";
import { AgentEvents } from "../../agents/BaseAgent";
import { RobotAgent } from "../RobotAgent";
import { RTVisualizer } from "./RTVisualizer";
import * as THREE from "three";
export class SLAMMapVisualizer extends RTVisualizer {
  public geometry = new THREE.PlaneGeometry(1, 1);
  public material = new THREE.MeshPhongMaterial({
    // color: 0x858585,
    side: THREE.DoubleSide,
    opacity: 0.5,
    transparent: true,
  });
  public plane = new THREE.Mesh(this.geometry, this.material);
  constructor(agent: RobotAgent) {
    super(agent);
    this.plane.name = 'slamMapPlane';
    this.plane.visible = false;
    const siteObj = agent.visual.wr.dataService.activeSite!.obj;
    const previous = siteObj.getObjectByName('slamMapPlane');
    previous?.removeFromParent();
    siteObj.add(this.plane);
    this.plane.position.z = 0.06;
    this.agent.on(AgentEvents.StateChange, (dgram: Partial<RobotAgent>) => {
      if (dgram.navMode === NavMode.SLAM) {
        this.plane.visible = true;
      } else if (dgram.navMode) {
        this.plane.visible = false;
      }
    });
  }

  public async updateSlamMap(map: RobotSlamMap) {
    if (!this.active) {
      return;
    }
    const { width, height, texture } = await loadTextureFromBuffer(map.data!);
    const scaledWidth = width * map.resolution;
    const scaledHeight = height * map.resolution;
    this.geometry.dispose();
    this.geometry = new THREE.PlaneGeometry(scaledWidth, scaledHeight);
    this.plane.geometry = this.geometry;
    this.material.map = texture;
    this.plane.position.x = map.offsetX + (scaledWidth / 2);
    this.plane.position.y = map.offsetY + (scaledHeight / 2);
    // this.plane.rotation.set(0, 0, -this.agent.visual.obj.rotation.z);
    this.plane.visible = true;
    // this.disappearTimeout = setTimeout(() => this.plane.visible = false, 5000);
  }
}